import React from 'react'
import {ListGuesser} from '@api-platform/admin'
import {Filter, TextInput, TextField, ReferenceField} from 'react-admin'
import ListPagination from "../../../components/admin/ListPagination"

import PostBulkActionButtons from "../../../components/admin/PostBulkActionButtons";
import ListActions from "../../../components/admin/Actions";
import {useTranslation} from "react-i18next";

function List(props) {
    const {t} = useTranslation()
    return (
        <ListGuesser
            perPage={30}
            pagination={<ListPagination/>}
            {...props}
            filters={<Filter>
                <TextInput label={t('common.name')} source="name"/>
            </Filter>}
            bulkActionButtons={<PostBulkActionButtons
                //showExportButton={true}
                showDeleteButton={true/*Roles.hasAccess('ClientsEdit')*/}
            />}
            actions={<ListActions
                showNewButton={true/*Roles.hasAccess('ClientsEdit')*/}
                //showExportButton={true}
            />}
        >
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="code" label={t('admin.code')}/>
            <TextField source="foreignId" label={'foreignId'}/>
            <ReferenceField source="media" reference="dictionary/medias" link={false} label={t('admin.media')}
                            sortable={false}>
                <TextField source="name"/>
            </ReferenceField>
        </ListGuesser>
    )
}

export default List
